import { Flex, Heading } from "@aws-amplify/ui-react";

export default function FlexFormContainer({ children, headerTitle }) {
  return (
    <Flex
      gap="24px"
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="32px 32px 32px 32px"
    >
      <Heading level="3" children={headerTitle}></Heading>
      {children}
    </Flex>
  );
}
